export default "__VITE_ASSET__D$$aK2$U__"